import { Array } from '@blade/std-lib'
import { FUN_ENABLED, PREMIUM_ENABLED } from '@root/shared'
import {
  CandleChartFilledIcon,
  Crown2Icon,
  DelugeIcon,
  NftIcon,
} from '@root/shared/ui-kit'

import {
  PremiumPlatformFilledIcon,
  NftPlatformFilledIcon,
  PumpPlatformFilledIcon,
  TerminalPlatformFilledIcon,
} from '../ui/platform-icon/platform-icon-create'

import { NFT, Premium, Pump, Terminal } from './platform-tokens'

import type { Platform } from './platform-tokens'
import type { IconProps } from '@root/shared/ui-kit'

export const platforms: Array<Platform> = Array.compact([
  Terminal,
  FUN_ENABLED ? Pump : undefined,
  //NFT,
  PREMIUM_ENABLED ? Premium : undefined,
])

export const PLATFORM_LABEL_MAP: Record<Platform, string> = {
  [Terminal]: 'Terminal',
  [Pump]: 'Pump',
  [NFT]: 'NFT',
  [Premium]: 'Premium',
}

export const PLATFORM_LOGO_MAP: Record<
  Platform,
  {
    Filled: React.FC<IconProps>
    Outlined: React.FC<IconProps>
  }
> = {
  [Terminal]: {
    Filled: CandleChartFilledIcon,
    Outlined: TerminalPlatformFilledIcon,
  },
  [Pump]: {
    Filled: DelugeIcon,
    Outlined: PumpPlatformFilledIcon,
  },
  [NFT]: {
    Filled: NftIcon,
    Outlined: NftPlatformFilledIcon,
  },
  [Premium]: {
    Filled: Crown2Icon,
    Outlined: PremiumPlatformFilledIcon,
  },
}

export * from './platform-tokens'
